var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "21.325pt",
    height: "18.9pt",
    viewBox: "929.423 -647.937 21.325 18.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)",
    strokeWidth: 0.501
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#323232",
    strokeWidth: 0.9,
    strokeMiterlimit: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 947.229,634.387 C 948.924,634.387 950.298,635.76 950.298,637.455 C 950.298,639.149 948.933,640.513 947.246,640.521 C 947.438,641.065 947.544,641.653 947.544,642.261 C 947.544,645.149 945.205,647.487 942.317,647.487 C 940.085,647.487 938.181,646.088 937.433,644.118 C 936.232,644.809 934.672,644.647 933.643,643.618 C 932.803,642.778 932.537,641.581 932.847,640.518 C 931.197,640.468 929.873,639.117 929.873,637.453 C 929.873,635.79 931.245,634.385 932.94,634.385",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 937.04,635.105 L 937.04,632.766 L 935.826,631.916",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 935.87,630.891 C 936.133,631.349 935.977,631.931 935.52,632.195 C 935.063,632.459 934.479,632.301 934.218,631.846 C 933.954,631.388 934.108,630.807 934.568,630.543 C 935.025,630.281 935.607,630.435 935.87,630.891 L 935.87,630.891 Z",
    fill: "none",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 943.13,635.105 L 943.13,632.766 L 944.345,631.914",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 944.3,630.891 C 944.036,631.349 944.193,631.931 944.65,632.195 C 945.108,632.459 945.69,632.301 945.953,631.846 C 946.216,631.388 946.06,630.807 945.603,630.543 C 945.146,630.281 944.563,630.435 944.3,630.891 L 944.3,630.891 Z",
    fill: "none",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 940.085,631.395 L 940.085,635.105",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 939.132,630.442 C 939.132,630.969 939.558,631.395 940.085,631.395 C 940.612,631.395 941.04,630.969 941.04,630.442 C 941.04,629.915 940.612,629.487 940.085,629.487 C 939.558,629.487 939.132,629.915 939.132,630.442 L 939.132,630.442 Z",
    fill: "none",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 940.462,637.378 L 940.462,641.655",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 940.462,639.516 L 941.948,639.516 C 942.444,639.516 942.845,639.918 942.845,640.413 L 942.845,640.761 C 942.845,641.257 942.446,641.658 941.948,641.658 L 940.462,641.658",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 944.648,641.655 L 944.648,637.378",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 935.522,637.378 L 936.618,641.299 C 936.68,641.511 936.869,641.655 937.09,641.655 L 937.09,641.655 C 937.309,641.655 937.5,641.511 937.561,641.299 L 938.658,637.378",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 938.262,638.802 L 935.923,638.802",
    fill: "none"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Imported Layer 1",
    transform: "scale(1 -1)",
    strokeWidth: 0.501
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "scale(1 -1)",
    strokeWidth: 0.501
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2",
    transform: "scale(1 -1)",
    strokeWidth: 0.501
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudApi);
export default __webpack_public_path__ + "static/media/cloud-api.79bf15329bbaa362a018a5f23cc83316.svg";
export { ForwardRef as ReactComponent };